export default {"src":"/_next/static/media/logo-purple.55274a0f.svg","height":177,"width":902,"blurWidth":0,"blurHeight":0};